import { ValidationError } from "../types";

const STATUS_CODE_VALIDATION = 400;

type Result =
  | {
      isValidationError: true;
      error: ValidationError;
    }
  | {
      isValidationError: false;
      error: null;
    };

export const getValidationError = (exception: any): Result => {
  if (
    exception &&
    exception.status === STATUS_CODE_VALIDATION &&
    exception.errors
  ) {
    return {
      isValidationError: true,
      error: exception,
    };
  } else {
    return { isValidationError: false, error: null };
  }
};
